import InventoryItemInterface from 'app/interfaces/InventoryItemInterface';
import LootInterface from 'app/interfaces/LootInterface';

export interface ArtifactLike {
    calculated_price?: number | string | null
    image?: InventoryItemInterface['image'] | {url: string}
    name?: string
    price?: number | string | null
    title?: string
}

export const artifactToLoot = (artifact: ArtifactLike): LootInterface => ({
    bonus: null,
    bonus_amount: 0,
    calculated_price: artifact.calculated_price ?? artifact.price ?? null,
    money_amount: 0,
    points_amount: 0,
    recipe: artifact as InventoryItemInterface,
    steam_skin: null,
    title: artifact.name || artifact.title || ''
});
